<template>
  <v-container
    style="position:absolute;left:50%;transform:translateX(-50%);"
    class="d-flex flex-column justify-center align-center"
  >
    {{ values.schritt }} / {{ values.anzahlSchritte }}
    <h1>
      Anfrage
    </h1>
    <p class="pa-6">
      Bitte gib an, wann und wo die Fahrt beginnen und enden soll
      und wie viele Fahrgäste du erwartest.
    </p>
    <v-form
      v-model="formvalid"
      class="pt-8"
    >
      <v-stepper v-model="e1" class="back lighten-1">
        <v-stepper-header>
          <v-stepper-step
            :complete="e1 > 1"
            step="1"
          >
            Abfahrt
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="e1 > 2"
            step="2"
          >
            Ankunft
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="e1 > 3"
            step="3"
          >
            Fahrgäste
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form v-model="formvalid">
              <div class="title pb-4 primary--text">Abfahrt</div>
              <p style="hyphens:manual !important;" class="pb-8">
                Wann und wo möchtest du abgeholt zu werden?
              </p>
              <v-row>
                <v-col cols="12" sm="6" class="py-0 pe-8">
                  <DatePicker
                    label="Tag"
                    v-model="value.datumStart"
                  />
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-autocomplete
                    label="Uhrzeit"
                    v-model="value.uhrzeitStart"
                    :items="moeglicheUhrzeiten"
                    :rules="[
                      this.$store.state.inputValidationRules.required
                    ]"
                  />
                </v-col>
              </v-row>
              <v-checkbox
                v-model="value.adresseUnbekannt"
                label="Adresse später angeben"
              />
              <div v-if="!value.adresseUnbekannt">
                <v-row>
                  <v-col class="py-0">
                    <v-text-field
                      label="Straße und Hausnummer"
                      v-model="value.adresseStart.strasse"
                      :rules="[
                        this.$store.state.inputValidationRules.required
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      type="number"
                      label="PLZ"
                      v-model="value.adresseStart.plz"
                      :rules="[
                        this.$store.state.inputValidationRules.required
                      ]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-text-field
                      label="Ort"
                      v-model="value.adresseStart.ort"
                      :rules="[
                        this.$store.state.inputValidationRules.required
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-form>
            <v-col class="py-0" align="right">
              <v-btn
                text
                color="primary"
                @click="abfahrtZuAnkunft();"
                :disabled="!formvalid"
              >
                Weiter
              </v-btn>
            </v-col>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form v-model="formvalid2">
              <div class="title pb-4 primary--text">Ankunft</div>
              <p style="hyphens:manual !important;" class="pb-8">
                Wann und wo soll die Fahrt beendet werden?
              </p>
              <v-row>
                <v-col cols="12" sm="6" class="py-0 pe-8">
                  <DatePicker
                    label="Tag"
                    v-model="value.datumEnde"
                  />
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-autocomplete
                    label="Uhrzeit"
                    v-model="value.uhrzeitEnde"
                    :items="moeglicheUhrzeiten.filter((o) => {
                      if (
                        (
                          value.datumStart === value.datumEnde
                          && o > value.uhrzeitStart
                        )
                        || value.datumStart !== value.datumEnde
                        ) {
                        return o;
                      }
                    })"
                    :rules="[
                      this.$store.state.inputValidationRules.required
                    ]"
                  />
                </v-col>
              </v-row>
              <div v-if="!value.adresseUnbekannt">
                <v-row>
                  <v-col class="py-0">
                    <v-text-field
                      label="Straße und Hausnummer"
                      v-model="value.adresseEnde.strasse"
                      :rules="[
                        this.$store.state.inputValidationRules.required
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      type="number"
                      label="PLZ"
                      v-model="value.adresseEnde.plz"
                      :rules="[
                        this.$store.state.inputValidationRules.required
                      ]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-text-field
                      label="Ort"
                      v-model="value.adresseEnde.ort"
                      :rules="[
                        this.$store.state.inputValidationRules.required
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col cols="4" class="py-0">
                  <span class="primary--text">{{ fahrtdauer }} Std.</span>
                </v-col>
              </v-row>
            </v-form>
            <!-- <div
              v-if="fahrtdauer !== 'NaN:NaN'"
            >
              <span class="primary--text">{{ fahrtdauer }} Std.</span>
            </div> -->
            <v-col class="py-0" align="right">
              <v-btn
                text
                @click="
                  e1 = 1;
                "
              >
                Zurück
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="
                  e1 = 3
                "
                :disabled="
                  !formvalid2
                  || fahrtdauer <= '00:00'
                "
              >
                Weiter
              </v-btn>
            </v-col>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-form v-model="formvalid3" class="pb-8">
              <div class="title pb-4 primary--text">Fahrgäste</div>
              <v-select
                label="Wie viele Gäste fahren mit?"
                v-model="value.fahrtgaeste"
                :items="[1, 2, 3, 4, 5, 6, 7, 8]"
                :rules="[
                  this.$store.state.inputValidationRules.required
                ]"
              />
              <!-- <v-select
                label="Gäste unter 18 Jahre"
                v-model="value.fahrtgaesteU18"
                :items="[0, 1, 2, 3, 4, 5, 6, 7, 8]"
              /> -->
            </v-form>
            <v-col class="py-0" align="right">
              <v-btn
                text
                @click="
                  e1 = 2;
                "
              >
                Zurück
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="
                  $emit('change', value);
                "
                :disabled="
                  !formvalid3
                  || value.fahrtgaeste < value.fahrtgaesteU18
                "
              >
                Weiter
              </v-btn>
            </v-col>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-form>
    <Impressum />
  </v-container>
</template>

<script>
import Impressum from '@/components/Impressum.vue';
import DatePicker from '@/components/Inputs/DatePicker.vue';

export default {
  name: 'BuchungFormFahrtdetails',
  components: {
    Impressum,
    DatePicker,
  },
  props: {
    prop_value: {
      type: Object,
      default() { return {}; },
    },
    values: {
      type: Object,
      default() { return {}; },
    },
  },
  data: () => ({
    e1: null,
    formvalid: true,
    formvalid2: true,
    formvalid3: true,
    value: {},
    moeglicheUhrzeiten: [],
  }),
  computed: {
    fahrtdauer() {
      const von = new Date(`${this.value.datumStart} ${this.value.uhrzeitStart}`.replace(/-/g, '/'));
      const bis = new Date(`${this.value.datumEnde} ${this.value.uhrzeitEnde}`.replace(/-/g, '/'));
      const timeVon = von.getTime();
      const timeBis = bis.getTime();
      let diff = parseFloat(timeBis) - parseFloat(timeVon);
      diff = parseFloat(diff) / 1000 / 60 / 60;
      const std = Math.floor(parseFloat(diff));
      const min = (diff - std) * 60;
      if (diff <= 0) {
        return '00:00';
      }
      return `${String(std).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
    },
  },
  methods: {
    abfahrtZuAnkunft() {
      if (this.value.adresseEnde.strasse === '') {
        this.value.adresseEnde.strasse = this.value.adresseStart.strasse;
        this.value.adresseEnde.plz = this.value.adresseStart.plz;
        this.value.adresseEnde.ort = this.value.adresseStart.ort;
      }
      if (this.value.datumEnde === '' || this.value.datumEnde <= this.value.datumStart) {
        if (this.value.datumEnde <= this.value.datumStart) {
          // Enddatum vor Startdatum
        }
        this.value.datumEnde = this.value.datumStart;
        if (this.value.uhrzeitEnde <= this.value.uhrzeitStart) {
          // Enduhrzeit vor Startuhrzeit
        }
      }
      this.e1 = 2;
    },
  },
  created() {
    this.value = JSON.parse(JSON.stringify(this.prop_value));
    this.moeglicheUhrzeiten = [];
    for (let i = 0; i <= (24 * 4); i += 1) {
      let j = i * 15;
      let k = Math.floor(j / 60);
      j = (j / 60 - k) * 60;
      j = String(j).padStart(2, '0');
      k = String(k).padStart(2, '0');
      this.moeglicheUhrzeiten.push(`${k}:${j}`);
    }
  },
};
</script>
